export const Alert = `
    <Alert 
        color="info" // String: default, info, warning, danger, success, primary
        icon="info"  // String: info, warning, danger, success   (predefined icons)
        label="Success Alert"  // String
        variant="solid" // String: solid, subtle, outline
        iconCustom={<IconAward size="sm"/>} // React node: Any "sm" base-icon added will override the default semantic icons
        className="custom-class" // String
    />
`
